import * as angular from 'angular';

class AvatarController {
  private isCommunity!: boolean;
  private initials!: boolean;

  public community!: string;
  public options: any;
  public size!: string;
  public classes!: string;

  $onInit() {
    if (this.community === 'true') {
      this.isCommunity = this.community === 'true';
    } else {
      this.initials = this.options && this.options.type === 'initials';
    }
  }
}

/**
 * @deprecated Prefer the `WorkspaceAvatarComponent`
 */
export const AvatarComponent: angular.IComponentOptions = {
  bindings: {
    options: '<',
    size: '@',
    classes: '@',
    community: '@',
  },
  template: `
<div
  ng-if="ctrl.initials"
  class="mode-avatar mode-avatar-initials mode-icon-{{ ctrl.size }} {{ ctrl.options.color_class }} {{ ctrl.classes }}">
  {{ ctrl.options.initials }}
</div>
<img
  ng-if="!ctrl.initials && !ctrl.isCommunity"
  class="mode-avatar mode-icon-{{ ctrl.size }} {{ ctrl.classes }}"
  ng-src="{{ ctrl.options.href }}" />
<div ng-if="ctrl.isCommunity" class="mode-avatar mode-avatar-initials mode-icon-{{ ctrl.size }} {{ ctrl.classes }}">
  <i class="icon-community-blue-24"></i>
</div>
`,
  controller: AvatarController,
  controllerAs: 'ctrl',
};
